import withEventDetailRedux from '../common/with_event_detail_redux';
import EventDetailContainer from './event_detail_container';

export default withEventDetailRedux(EventDetailContainer);
